import React__default, { useState } from 'react';
import UpArrowIcon from '../../../../assets/icons/up-arrow.icon.js';
import DownArrowSidebarIcon from '../../../../assets/icons/down-arrow-sidebar.icon.js';
import Typography from '../../../../Atoms/Typography.js';
import { useTranslation } from 'react-i18next';
import classNames from './../../../../external_lib/classnames/index.js';
import LazyImage from '../../../../Atoms/LazyImage.js';

function MultipleImageWeb(_a) {
    var imageList = _a.imageList, topExtras = _a.topExtras, imageComponent = _a.imageComponent;
    var _b = useState(0), imageSelected = _b[0], setImageSelected = _b[1];
    var _c = useState(0), startIndex = _c[0], setStartIndex = _c[1];
    var _d = useState(3), endIndex = _d[0], setEndIndex = _d[1];
    var handleUpArrow = function () {
        if (imageSelected > 0) {
            setImageSelected(imageSelected - 1);
            if (endIndex - imageSelected >= 3 && imageSelected > 0) {
                setStartIndex(startIndex - 1);
                setEndIndex(endIndex - 1);
            }
        }
        else {
            setImageSelected(imageList.length - 1);
            setEndIndex(imageList.length - 1);
            if (imageList.length < 4)
                setStartIndex(0);
            else
                setStartIndex(imageList.length - 4);
        }
    };
    var handleDownArrow = function () {
        if (imageSelected + 1 < imageList.length) {
            setImageSelected(imageSelected + 1);
            if (imageSelected - startIndex >= 3) {
                setStartIndex(startIndex + 1);
                setEndIndex(imageSelected + 1);
            }
        }
        else {
            setImageSelected(0);
            setStartIndex(0);
            if (imageList.length < 4)
                setEndIndex(imageList.length - 1);
            else
                setEndIndex(3);
        }
    };
    var t = useTranslation().t;
    return (React__default.createElement("div", { className: "multiple-image__container" },
        imageList.length > 1 ? (React__default.createElement("div", { className: "sideScrollBar" },
            React__default.createElement("div", { className: "upArrow", onClick: handleUpArrow },
                React__default.createElement(UpArrowIcon, null)),
            React__default.createElement("div", { className: "imageSlider" }, imageList
                .slice(startIndex, startIndex + 4)
                .map(function (image, index) { return (React__default.createElement("div", { className: "imageBox ".concat(imageSelected === startIndex + index
                    ? 'imageBoxSelected'
                    : ''), onClick: function () { return setImageSelected(startIndex + index); }, key: startIndex * 1000 + index },
                React__default.createElement(LazyImage, { classes: "imageInsideBox", src: image, imageComponent: imageComponent }))); })),
            React__default.createElement("div", { className: "downArrow", onClick: handleDownArrow },
                React__default.createElement(DownArrowSidebarIcon, null)))) : null,
        React__default.createElement("div", { className: classNames('mainImage', {
                mainImageSingle: imageList.length === 1
            }) },
            imageList.length > 1 && (React__default.createElement("div", { className: "image-count" },
                React__default.createElement(Typography, { classes: "image-count-text", variant: "bodyTextTwo" }, t("".concat(imageSelected + 1, "/").concat(imageList.length))))),
            React__default.isValidElement(topExtras) && (React__default.createElement("div", { className: "topExtras" }, React__default.cloneElement(topExtras))),
            React__default.createElement(LazyImage, { classes: "insideImageMain", src: imageList[imageSelected], imageComponent: imageComponent }))));
}

export { MultipleImageWeb as default };
//# sourceMappingURL=multiple-image-web.js.map
